import { isMediaFile } from '@wix/communities-blog-universal/dist/src/utils/media/file';
export const requestCredentials = (request, type) => request(`/_api/media/credentials/${type}`);
export const requestFileUploadUrl = (request, fileName, mimeType) => request.post('/v2/files/upload-url', { fileName, mimeType }, { retry: 2 });
export const requestFileDownloadUrl = (request, postId, filePath, fileId, mimeType) => isMediaFile(mimeType)
    ? request.post('/v2/media/download-url', { postId, fileId })
    : request.post('/v2/files/download-url', { postId, filePath });
//# sourceMappingURL=request-url.js.map